import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-primeiro-acesso-senha-definida-com-sucesso',
  imports: [MatButtonModule],
  templateUrl: './primeiro-acesso-senha-definida-com-sucesso.html',
  styleUrl: './primeiro-acesso-senha-definida-com-sucesso.scss',
})
export class PrimeiroAcessoSenhaDefinidaComSucesso {
  constructor(private readonly router: Router) {}

  irParaLogin() {
    this.router.navigate(['/auth/login']);
  }
}
